import { updateWebSafeRadius, validateArrayLength4 } from './EffectUtils.js';
import { ShaderEffect, } from './ShaderEffect.js';
/**
 * Masks the current maskcolor with rounded corners similar to {@link RoundedRectangle}
 */
export class RadiusEffect extends ShaderEffect {
    static z$__type__Props;
    name = 'radius';
    static getEffectKey() {
        return `radius`;
    }
    static uniforms = {
        radius: {
            value: 0,
            method: 'uniform4fv',
            type: 'vec4',
            updateOnBind: true,
            validator: validateArrayLength4,
            updateProgramValue: updateWebSafeRadius,
        },
    };
    static methods = {
        fillMask: `
      float function(float dist) {
        return clamp(-dist, 0.0, 1.0);
      }
    `,
        boxDist: `
      float function(vec2 p, vec2 size, float radius) {
        size -= vec2(radius);
        vec2 d = abs(p) - size;
        return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;
      }
    `,
    };
    static resolveDefaults(props) {
        return {
            radius: props.radius ?? 10,
        };
    }
    static onShaderMask = `
  vec2 halfDimensions = u_dimensions * 0.5;
  float r = radius[0] * step(v_textureCoordinate.x, 0.5) * step(v_textureCoordinate.y, 0.5);
  r = r + radius[1] * step(0.5, v_textureCoordinate.x) * step(v_textureCoordinate.y, 0.5);
  r = r + radius[2] * step(0.5, v_textureCoordinate.x) * step(0.5, v_textureCoordinate.y);
  r = r + radius[3] * step(v_textureCoordinate.x, 0.5) * step(0.5, v_textureCoordinate.y);
  return $boxDist(v_textureCoordinate.xy * u_dimensions - halfDimensions, halfDimensions, r);
  `;
    static onEffectMask = `
  return mix(vec4(0.0), maskColor, $fillMask(shaderMask));
  `;
}
//# sourceMappingURL=RadiusEffect.js.map